import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SalesBubbleRegularAi from './sales-bubble-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SalesBubbleRegularAi {...validProps} />;
}
SvgComponent.iconName = 'salesBubbleRegularAi';

export const SalesBubbleRegularAiIcon = svgIconWrapper(SvgComponent);
